// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_nw-0";
export var discountCodeInput = "_nw-1";